import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  transform(value: any, searchText: string): any {
    if (!searchText) {
      return value;
    }
    return value.replace(new RegExp(searchText, 'gi'), match => {
      return `<strong>${match}</strong>`;
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/highlight.pipe.ts